const MINUTE = 60 * 1000;
const HOUR = 60 * MINUTE;
const DAY = 24 * HOUR;
const MONTH_APPROX = 30 * DAY;

// Instagram-style relative/absolute post age, for indefinite (non-expiring)
// posts. Uses the browser's local timezone via Intl.DateTimeFormat — no
// manual offset math.
export function formatPostTimestamp(createdAt) {
  if (!createdAt) return "";

  const created = new Date(createdAt);
  if (Number.isNaN(created.getTime())) return "";

  const now = new Date();
  const diff = now.getTime() - created.getTime();

  if (diff < MINUTE) return "Just now";

  if (diff < HOUR) {
    const minutes = Math.floor(diff / MINUTE);
    return `${minutes} minute${minutes === 1 ? "" : "s"} ago`;
  }

  if (diff < DAY) {
    const hours = Math.floor(diff / HOUR);
    return `${hours} hour${hours === 1 ? "" : "s"} ago`;
  }

  if (diff < MONTH_APPROX) {
    const days = Math.floor(diff / DAY);
    return `${days} day${days === 1 ? "" : "s"} ago`;
  }

  // Absolute date once it's been roughly a month or more — year is only
  // included once the post falls in a different calendar year, matching
  // how Instagram/similar feeds actually switch (not a strict 365-day count).
  const sameYear = created.getFullYear() === now.getFullYear();
  return new Intl.DateTimeFormat(undefined, {
    month: "long",
    day: "numeric",
    year: sameYear ? undefined : "numeric",
  }).format(created);
}
